import { useEffect } from "react";
import { useTranslation } from 'react-i18next';

import LangSelector, { langSelector } from './LangSelector.jsx';
import { useBl, useEnllacosBl } from './modoBl.js';

import "../../../../../css/web/motor/styles.css";

import { Helmet } from "react-helmet";

const MenuBuit = ({ idiomas, lang, config, ruta, meta_titulo, meta_descripcion, meta_keywords }) => {

    useEnllacosBl(useBl());


    useEffect(() => {
        if (config.color_corporativo_web) {
            document.documentElement.style.setProperty('--corporatiu', config.color_corporativo_web);
        }
    }, [config.color_corporativo_web]);
    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    useEffect(() => {

        if (config.css_personalizado) {
            const linkElement = document.createElement('link');
            linkElement.rel = 'stylesheet';
            linkElement.type = 'text/css';
            linkElement.href = config.css_personalizado;
            const headElement = document.head;
            headElement.appendChild(linkElement);
        }

    }, []);

    return (
        <>
            {/* ********** */}

            <Helmet>
                <title>{`${((typeof window !== "undefined" && window.__SEO__?.title) || meta_titulo)}`}</title>
                <meta name="title" content={`${((typeof window !== "undefined" && window.__SEO__?.title) || meta_titulo)}`} />
                <meta name="description" content={(typeof window !== "undefined" && window.__SEO__?.description) || (`${meta_descripcion}`)} />
                <meta name="keywords" content={`${meta_keywords}`} />
                <meta charset="utf-8" />
            </Helmet>

            {
                (config.id === 1) ?
                    <Helmet>
                        <link rel="icon" type="image/x-icon" href={`${ruta}/web/favicon/favicon.ico`}></link>
                    </Helmet>
                    :
                    <Helmet>
                        <link rel="icon" type="image/x-icon" href={`${ruta}/web/favicon/${config.id}/favicon.ico`}></link>
                    </Helmet>
            }

            {
                (config.activa_analytics === 1) ?
                    <Helmet>
                        <script async src={`https://www.googletagmanager.com/gtag/js?id=${config.codigo_analytics}`}></script>
                        <script>
                            {`
                                window.dataLayer = window.dataLayer || [];
                                function gtag(){window && window.dataLayer && window.dataLayer.push(arguments)}
                                gtag('js', new Date())
                                gtag('config', '${config.codigo_analytics}');
                            `}
                        </script>
                    </Helmet>
                    :
                    ""
            }
            <div style={{ display: "none" }}>
                <LangSelector
                    idiomas={idiomas}
                    langactual={lang.toString().toUpperCase()}
                />
            </div>
        </>
    );
}

export default MenuBuit;
